import React, { useState } from 'react';
import AddCourseModal from '../Components/AddCourseModal';

const useModal = () => {
  const [openModal, setOpenModal] = useState(false);

  const modal = ({ acceptText = '', onAccept = () => {} }) => {
    if (!openModal) {
      return <div />;
    }

    return (
      <div>
        <AddCourseModal
          acceptText={acceptText}
          close={() => {
            setOpenModal(!openModal);
          }}
          open={openModal}
          onAccept={onAccept}
        />
      </div>
    );
  };

  return {
    AddCourseModal: modal,
    openModal,
    setOpenModal,
  };
};

export default useModal;
